import { Injectable } from "@angular/core";
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef, SimpleSnackBar } from "@angular/material/snack-bar";
import { NotificationComponent } from "./notification.component";

@Injectable()
export class NotificationService {
  constructor(private snackBar: MatSnackBar) {}

  public success(message: string, action?: string, config?: MatSnackBarConfig): MatSnackBarRef<NotificationComponent> {
    const snackBarConfig = this.buildSnackBarConfig(message, action, "success", config);
    snackBarConfig.panelClass = ["success-snackbar"];
    return this.snackBar.openFromComponent(NotificationComponent, snackBarConfig);
  }

  public error(message: string, action?: string, config?: MatSnackBarConfig): MatSnackBarRef<NotificationComponent> {
    const snackBarConfig = this.buildSnackBarConfig(message, action, "error", config);
    snackBarConfig.panelClass = ["error-snackbar"];
    return this.snackBar.openFromComponent(NotificationComponent, snackBarConfig);
  }

  public warning(message: string, action?: string, config?: MatSnackBarConfig): MatSnackBarRef<NotificationComponent> {
    const snackBarConfig = this.buildSnackBarConfig(message, action, "warning", config);
    snackBarConfig.panelClass = ["warning-snackbar"];
    return this.snackBar.openFromComponent(NotificationComponent, snackBarConfig);
  }

  public info(message: string, action?: string, config?: MatSnackBarConfig): MatSnackBarRef<SimpleSnackBar> {
    const snackBarConfig = this.buildSnackBarConfig(message, action, "info", config);
    return this.snackBar.open(message, action || "OK", snackBarConfig);
  }

  private buildSnackBarConfig(
    message: string,
    action: string,
    cssPrefix: string,
    config?: MatSnackBarConfig,
  ): MatSnackBarConfig {
    const snackBarConfig = config || new MatSnackBarConfig();
    const data = { message, action: action || "OK", cssPrefix };
    snackBarConfig.data = data;
    snackBarConfig.duration = snackBarConfig.duration ? snackBarConfig.duration : 5000;
    return snackBarConfig;
  }
}
